/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sku: NonNullable<unknown> }} Online_Price_Input_LabelInputs */

const vi_online_price_input_label = /** @type {(inputs: Online_Price_Input_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Giá Online gồm VAT của ${i?.sku}`)
};

/**

* @param {Online_Price_Input_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_input_label = /** @type {((inputs: Online_Price_Input_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_Input_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_input_label(inputs)
});